import template from './reset_atm_code.all.html';
import controller from './reset_atm_code.all.controller';
import './reset_atm_code.all.scss';

let resetAtmCodeAllComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template,
  controller
};

export default resetAtmCodeAllComponent;


// WEBPACK FOOTER //
// ./client/app/components/reset_atm_code/all/reset_atm_code.all.component.js